<template>
  <div class="tool-index-menu">
    <div class="tool-index-menu__header">
    </div>

    <div v-if="loading" class="tool-index-menu__loading">
      <p>Carregando índice...</p>
    </div>

    <div v-else-if="allTools.length > 0" class="tool-index-menu__items">
      <ToolMenuItem
        v-for="item0 in allTools"
        :key="item0.id"
        :item="item0"
        :expanded-items="expandedItems"
        :level="0"
        @toggle-expand="toggleExpand"
        @menu-click="handleMenuItemClick"
      />
    </div>

    <div v-else class="tool-index-menu__empty">
      <p>Nenhuma ferramenta encontrada.</p>
    </div>
  </div>
</template>

<script>
import { useToolIndex } from './script';
import ToolMenuItem from './ToolMenuItem.vue';

export default {
  name: 'ToolIndex',
  components: {
    ToolMenuItem,
  },
  setup() {
    const { allTools, loading, expandedItems, toggleExpand, handleMenuItemClick } = useToolIndex();
    return {
      allTools,
      loading,
      expandedItems,
      toggleExpand,
      handleMenuItemClick,
    };
  },
};
</script>

<style scoped>
@import './style.css';
</style>